import { PlusCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/config/paths';

export default function CreateSaleDisplay() {
  const navigate = useNavigate();

  return (
    <div
      className="col-span-6 lg:col-span-3 xl:col-span-2 rounded-lg py-14 shadow-sm shadow-black/5 cursor-pointer bg-white flex items-center justify-center gap-2"
      onClick={() => {
        navigate(paths.sales.create.getHref());
      }}
    >
      <PlusCircle className="text-violet-500" size={24} /> Skapa ny
    </div>
  );
}
